import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const DisabledText = styled.div(props => ({
    ...theme(props).typography.smallFont.css(),
    color: theme(props).typography.inactive.color,
}));

export const ButtonsContainer = styled.div({
    marginLeft: 10,
});

export const ButtonsLine = styled.span({
    display: "flex",
});
